import { FileSpreadsheet } from "lucide-react";
import type { ExcelArtifact } from "~/components/assistant/types";

interface ExcelMessageProps {
  excel: ExcelArtifact;
  debugMode?: boolean;
}

export function ExcelMessage({ excel }: ExcelMessageProps) {
  return (
    <div
      className="bg-white border border-gray-200 rounded-lg p-4 w-full flex items-center gap-3"
      aria-label="Excel file display"
    >
      <FileSpreadsheet className="size-8 text-green-600 shrink-0" />
      <div className="min-w-0 flex-1">
        <div className="text-sm font-medium text-gray-900 truncate">{excel.content.file_name}</div>
        {excel.content.sheet_names && excel.content.sheet_names.length > 0 && (
          <div className="text-xs text-gray-500 mt-0.5">{excel.content.sheet_names.join(", ")}</div>
        )}
        {excel.summary && <div className="text-xs text-gray-500 mt-1">{excel.summary}</div>}
      </div>
    </div>
  );
}
